


































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import copy from '@/utils/copy';

@Component({})
export default class ChartTrace extends Vue {
  @Prop() private intervalTime!: any;
  @Prop() private data!: any;
  private appChange(i: any) {
    const temp = { key: `${i.key}`, label: i.label };
  }
  get maxValue() {
    const temp: number[] = this.data.map((i: any) => i.value);
    return Math.max.apply(null, temp);
  }
  private handleClick(i: any) {
    copy(i);
  }
}
